export const STANDARD_LIGHT = {
    primary: '#2860E1',
    background: '#ffffff',
    text: '#111827',
    muted: '#64748b',
    headerBg: '#ffffff',
    buttonBg: '#2860E1',
    buttonText: '#ffffff',
    link: '#2860E1',
    border: '#e2e8f0',
    surface: '#ffffff',
};

export const STANDARD_DARK = {
    primary: '#2860E1',
    background: '#0F172A',
    text: '#F8FAFC',
    muted: '#CBD5E1',
    headerBg: '#020617',
    buttonBg: '#2860E1',
    buttonText: '#FFFFFF',
    link: '#60A5FA',
    border: '#334155',
    surface: '#1E293B',
};

const REQUIRED_KEYS = ['primary', 'background', 'text', 'headerBg', 'buttonBg', 'buttonText'];

export function isCompletePalette(palette) {
    return Boolean(palette) && REQUIRED_KEYS.every((key) => typeof palette[key] === 'string' && palette[key].trim());
}

export function standardPalette(mode) {
    return mode === 'dark' ? STANDARD_DARK : STANDARD_LIGHT;
}

function brandColors(palette) {
    return {
        primary: palette.primary,
        headerBg: palette.headerBg,
        buttonBg: palette.buttonBg,
        buttonText: palette.buttonText,
        link: palette.primary,
    };
}

function darkAdminPalette(palette) {
    return {
        ...standardPalette('dark'),
        ...brandColors(palette),
    };
}

function lightAdminPalette(palette) {
    return brandColors(palette);
}

export function resolveCommunityPalette(community, mode) {
    const tokens = community?.brandingSource === 'ADMIN' ? community.themeTokens : null;
    const palette = mode === 'dark' ? tokens?.dark : tokens?.light;
    if (isCompletePalette(palette)) {
        if (mode === 'dark') {
            return { source: 'admin', palette: darkAdminPalette(palette) };
        }
        // Light keeps legacy page, text, border, and input colors. Only brand roles are custom.
        return { source: 'admin', palette: lightAdminPalette(palette) };
    }
    if (mode === 'light' && community?.brandingSource !== 'ADMIN') {
        return { source: 'legacy', palette: null };
    }
    return { source: 'standard', palette: standardPalette(mode) };
}

export function resolveCommunityLogo({ mode, logoUrl, darkLogoUrl, fallback = '' }) {
    if (mode === 'dark') {
        return darkLogoUrl || logoUrl || fallback;
    }
    return logoUrl || fallback;
}
